import React from "react"

import type { TestCaseRecord } from "@/types/api/TestCaseRecord"
import type { MetricRecordData } from "@/types/metrics/contracts"
import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { appendAgentJudgeEvidence } from "../agent-judge/agentJudgeEvidence"
import {
  AgentJudgeMetadataEditor,
  AgentJudgeReadOnlyMetadata,
} from "../agent-judge/AgentJudgeMetadataEditor"
import { BinaryLLMMetricRecord } from "./BinaryLLMMetricRecord"

type DeepDiveTestCase = Pick<
  TestCaseRecord,
  "input_str" | "expected_behaviors" | "expected_output_json"
>

export class AgentJudgeMetricRecord extends BinaryLLMMetricRecord {
  renderReadOnlyMetadata(metricRecordData: MetricRecordData): React.ReactNode {
    return (
      <AgentJudgeReadOnlyMetadata metricRecordData={metricRecordData}>
        {super.renderReadOnlyMetadata(metricRecordData)}
      </AgentJudgeReadOnlyMetadata>
    )
  }

  getDeepDiveSections(
    metricOutput: RunMetricOutput,
    testCase: DeepDiveTestCase,
  ): { label: string; content: React.ReactNode }[] | null {
    return appendAgentJudgeEvidence(
      super.getDeepDiveSections(metricOutput, testCase),
      metricOutput,
    )
  }

  renderEditorMetadata(
    metricRecordData: MetricRecordData,
    onChange: (metric: MetricRecordData) => void,
    textAreaRef?: React.RefObject<HTMLTextAreaElement>,
  ): React.ReactNode {
    return (
      <AgentJudgeMetadataEditor
        metricRecordData={metricRecordData}
        onChange={onChange}
        textAreaRef={textAreaRef}
        questionPlaceholder={
          'Enter a yes/no question.\n\nExample: "Did the agent verify the customer\'s account before discussing order details?"\n\nThe Agent Judge investigates only through the enabled read-only tools and returns YES, NO, or UNKNOWN.'
        }
      />
    )
  }
}
